import { getRegion, setURL } from "./helper/functions/functions";

const region = getRegion();
const twVendorNav = [
  {
    name: "OKmart Reports",
    url: setURL(`reports/okmartreports`, region),
    icon: "cui-file",
    permission: "ADMIN_REPORTS_ANY_READ",
    menuname: "balance_reports"
  },
  {
    name: "FamilyMart Reports",
    url: setURL(`reports/familymartreports`, region),
    icon: "cui-file",
    permission: "ADMIN_REPORTS_ANY_READ",
    menuname: "balance_reports"
  },
]
let vendorNav = region === "tw" ? twVendorNav : []; 
const nav = {
  items: [
    {
      name: "Dashboard",
      url: setURL('dashboard', region),
      icon: "icon-speedometer"
    },
    {
      name: "Analytics+",
      url: setURL('analytics', region),
      icon: "fa fa-line-chart"
    },
    {
      name: "Admin Management",
      icon: "icon-user",
      children: [
        {
          name: "Management",
          url: setURL('admins', region),
          // url: `/${region}/admins`,
          icon: "icon-user",
          multiIcon: "fa fa-user-circle multi-icon",
          isMulti: true,
          permission: "ADMIN_REPORTS_ANY_READ",
          specialpermission: ["developer"]
        },
        {
          name: "KPI",
          url: setURL('kpi', region),
          icon: "fa fa-bar-chart-o",
          multiIcon: "fa fa-bar-chart-o multi-icon",
          isMulti: true,
          // permission: "ADMIN_REPORTS_ANY_READ",
          specialpermission: ["developer"]
        },
        // {
        //   name: "Time Table",
        //   url: setURL('timetable', region),
        //   icon: "fa fa-calendar-check-o",
        //   // permission: "ADMIN_REPORTS_ANY_READ",
        //   specialpermission: ["developer"]
        // },
        {
          name: "IMEI Exception",
          url: setURL('imeiexception', region),
          icon: "fa fa-id-badge",
          multiIcon: "fa fa-id-badge multi-icon",
          isMulti: true,
          permission: "ADMIN_REPORTS_ANY_READ",
          specialpermission: ["developer"]
        }
        // {
        //   name: "Timesheet",
        //   url: '/attendance/requestedleave',
        //   icon: "fa fa-clock-o",
        // }
      ],
      // permission: "ADMIN_ADMIN_ANY_READ"
      // permission: "ADMIN_REPORTS_ANY_READ",
      // specialpermission: ["developer"]
    },
    {
      name: 'Chat',
      url: setURL('chat', region),
      icon: "fa fa-comments",
      permission: "ADMIN_REPORTS_ANY_READ",
    },
    {
      name: "Log Call",
      url: setURL('log-calls', region),
      icon: "fa fa-address-book-o",
      permission: "LOGCALLS_ANY_READ"
    },
    {
      name: "User Management",
      url: setURL("users", region),
      icon: "icon-people",
      permission: "ADMIN_USERS_ANY_READ"
    },
    {
      name: "Order Management",
      url: setURL('orders', region),
      icon: "cui-cart",
      permission: "ORDERS_ANY_READ"
    },
    {
      name: "Search Order",
      url: setURL('searchallorder', region),
      icon: "fa fa-search",
      permission: "ORDERS_ANY_READ"
    },
    // {
    //   name: "Order Request",
    //   url: "/order-request",
    //   icon: "cui-list"
    // },
    {
      name: "Payments",
      url: setURL('payments', region),
      icon: "cui-dollar",
      permission: "TOPUPS_ANY_READ"
    },
    {
      name: "Merchant",
      url: "/merchants",
      icon: "cui-home",
      multiIcon: "fa fa-cubes multi-icon",
      isMulti: true,
      children: [
        {
          name: "List Merchant",
          url: setURL('merchants/listmerchant', region),
          icon: "cui-home",
          // permission: "MARKETING_ANY_READ",
          permission: "ADMIN_REPORTS_ANY_READ",
          multiIcon: "fa fa-cubes multi-icon",
          isMulti: true,
        },
        {
          name: "Product Request",
          url: setURL('merchants/productrequest', region),
          icon: "cui-home",
          // permission: "MARKETING_ANY_READ",
          permission: "ADMIN_REPORTS_ANY_READ",
          multiIcon: "fa fa-cubes multi-icon",
          isMulti: true,
        },
        {
          name: "Merchant Products",
          url: setURL('merchants/merchantproducts', region),
          icon: "cui-home",
          permission: "MARKETING_ANY_READ",
          multiIcon: "fa fa-cubes multi-icon",
          isMulti: true,
        },
        {
          name: "Merchant Orders",
          url: setURL('merchants/merchantorder', region),
          icon: "cui-home",
          permission: "VOUCHERS_ANY_READ",
          multiIcon: "fa fa-cubes multi-icon",
          isMulti: true,
        }
      ],
    },
    // {
    //   name: "Affiliate",
    //   url: "/affiliator",
    //   icon: 'cui-user',
    //   children: [
    //     {
    //       name: "Management",
    //       url: "/affiliator/manage",
    //       icon: "cui-user"
    //     },
    //     {
    //       name: "Withdraw Request",
    //       url: "/affiliator/withdraw-request",
    //       icon: "cui-user"
    //     }
    //   ],
    //   permission: "AFFILIATE_ANY_READ"
    // },
    {
      name: "Voucher Management",
      url: setURL('vouchers', region),
      icon: "fa fa-tags",
      permission: "VOUCHERS_ANY_READ",
    },
    {
      name: "Brands",
      url: "/brands",
      icon: "fa fa-tag",
      multiIcon: "fa fa-tag multi-icon",
      isMulti: true,
      children: [
        {
          name: "Digital Brands",
          url: setURL('brands/digital', region),
          icon: "cui-layers",
          multiIcon: "fa fa-tag multi-icon",
          isMulti: true,
        }
      ],
      // permission: "BRANDS_ANY_READ"
      permission: "VOUCHERS_ANY_READ",
    },
    {
      name: "Products",
      url: "/products",
      icon: "fa fa-archive",
      multiIcon : "fa fa-archive multi-icon",
      isMulti: true,
      children: [
        {
          name: "Digital Product",
          url: setURL('products/digital', region),
          icon: "fa fa-archive",
          multiIcon : "fa fa-archive multi-icon",
          isMulti: true,
        },
        {
          name: "ID Product",
          url: setURL('products/id', region),
          icon: "fa fa-archive",
          multiIcon : "fa fa-archive multi-icon",
          isMulti: true,
        },
        // {
        //   name: "HP Hongkong",
        //   url: "/products/hphongkong",
        //   icon: "fa fa-archive"
        // }
      ],
      permission: "PRODUCTS_ANY_READ"
    },
    {
      name: "Categories",
      url: "/categories",
      icon: "cui-layers",
      multiIcon : "cui-layers multi-icon",
      isMulti: true,
      children: [
        {
          name: "Digital Categories",
          url: setURL('categories/digital', region),
          icon: "cui-layers",
          multiIcon : "cui-layers multi-icon",
          isMulti: true,
        },
        {
          name: "ID Categories",
          url: setURL('categories/id', region),
          icon: "cui-layers",
          multiIcon : "cui-layers multi-icon",
          isMulti: true,
        }
      ],
      // permission: "CATEGORIES_ANY_READ"
      permission: "VOUCHERS_ANY_READ",
    },
    {
      name: "Marketings",
      url: "/marketings",
      icon: "cui-pie-chart",
      children: [
        {
          name: "Giveaway",
          url: setURL('marketings/giveaway', region),
          // icon: "cui-pie-chart",
          icon: "fa fa-gift"
        },
        {
          name: "Code Promotions",
          url: setURL('marketings/coupons', region),
          // icon: "cui-pie-chart",
          icon: "fa fa-percent",
          multiIcon : "fa fa-percent multi-icon",
          isMulti: true,
        },
        {
          name: "Referrals",
          url: setURL('marketings/referrals', region),
          // icon: "cui-pie-chart",
          icon: "fa fa-users"
        },
        {
          name: "Banners",
          url: setURL('marketings/banners', region),
          // icon: "cui-pie-chart",
          icon: "fa fa-columns",
          multiIcon : "fa fa-columns multi-icon",
          isMulti: true,
        },
        {
          name: "Popup Banners",
          url: setURL('marketings/popupimages', region),
          // icon: "cui-pie-chart",
          icon: "fa fa-columns",
          multiIcon : "fa fa-columns multi-icon",
          isMulti: true,
        },
        {
          name: "Broadcast",
          url: "/marketings/broadcast",
          // icon: "cui-pie-chart",
          icon: "fa fa-bullhorn"
        },
        {
          name: "Shorten URL",
          url: setURL('marketings/urlshortener', region),
          // icon: "cui-pie-chart",
          icon: "fa fa-link",
          multiIcon : "fa fa-link multi-icon",
          isMulti: true
        },
        {
          name: "Product Promo",
          url: setURL('marketings/productpromo', region),
          // icon: "cui-pie-chart",
          icon: "fa fa-pie-chart",
          multiIcon : "fa fa-pie-chart multi-icon",
          isMulti: true
        },
        {
          name: "iDeal Homepage",
          url: "/marketings/homepage",
          // icon: "cui-pie-chart",
          icon: "fa fa-window-restore",
          multiIcon : "fa fa-window-restore multi-icon",
          isMulti: true,
        },
      ],
      permission: "MARKETING_ANY_READ"
    },
    {
      name: "SMS i-Deal",
      url: "/smsserver",
      icon: "fa fa-envelope-o",
      children: [
        // {
        //   name: "SMS i-Deal",
        //   url: "/smsserver/smsserverlist",
        //   icon: "fa fa-envelope-o",
        // },
        {
          name: "OTP i-Deal",
          url: "/smsserver/otplist",
          icon: "fa fa-envelope-o",
        }
      ],
      // permission: "MARKETING_ANY_READ"
      permission: "ADMIN_REPORTS_ANY_READ",
    },
    {
      name: "Collections",
      url: setURL("collections", region),
      icon: "fa fa-star",
      multiIcon: "fa fa-star multi-icon",
      isMulti: true,
      permission: "COLLECTIONS_ANY_READ",
    },
    {
      name: "Settings",
      url: setURL('settings', region),
      icon: "cui-settings",
      multiIcon: "cui-settings multi-icon",
      isMulti: true,
      permission: "SETTINGS_ANY_READ",
    },
    {
      name: "Report",
      url: "/reports",
      icon: "cui-file",
      children: [
        {
          name: "Payment Report",
          url: setURL(`reports/payments`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "payment_reports"
        },
        {
          name: "Risk MGMT Report",
          url: setURL(`reports/riskmgmtreport`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "oa_reports",
        },
        {
          name: "Purchase Report",
          url: setURL(`reports/purchasereport`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "purchase_reports",
          multiIcon : "cui-file multi-icon",
          isMulti: true,
        },
        {
          name: "ID Settlement Report",
          url: setURL(`reports/settlementreports`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "jd_settlement_reports",
          multiIcon : "cui-file multi-icon",
          isMulti: true,
        },
        {
          name: "MD Settlement Report",
          url:  setURL(`reports/mdsettlementreport`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "md_order_report",
          multiIcon : "cui-file multi-icon",
          isMulti: true,
        },
        {
          name: "Merchant Settlement Report",
          url:  setURL(`reports/merchantsettlementreport`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "merchant_order_report",
          multiIcon : "cui-file multi-icon",
          isMulti: true,
        },
        // {
        //   name: "HPHongkong Settlement Reports",
        //   url: "/reports/hphongkong",
        //   icon: "cui-file"
        // },
        {
          name: "Saldoku Report",
          url: setURL(`reports/saldokureports`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "balance_reports"
        },
        {
          name: "ID Sale Report",
          url: setURL(`reports/sale/id`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "jd_sale_reports"
        },
        {
          name: "Digital Sale Report",
          url: setURL('reports/sale/digital', region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "digital_sale_reports"
        },
        {
          name: "Refund Report",
          url: setURL('reports/refund', region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "refund_reports"
        },
        {
          name: "User Report",
          url: setURL(`reports/user`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "user_reports"
        },
        {
          name: "7Eleven Report",
          url: setURL(`reports/7elevenreports`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "balance_reports"
        },
        ...vendorNav,
        {
          name: "Payment Input Report",
          url: setURL('reports/payment-order', region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "payment_input_reports"
        },
        {
          name: "Access Contact Report",
          url: setURL(`reports/tokencontactaccess`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "access_contact_reports"
        },
        {
          name: "Sales Order Report",
          url: setURL(`reports/salestakeorderreport`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "sales_order_report"
        },
        {
          name: "Promo Code Report",
          url: setURL(`reports/coupon`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "promo_code_reports"
        },
        {
          name: "Collector Report",
          url: setURL(`reports/collectorreports`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "collector_reports"
        },
        {
          name: "Gift Report",
          url: setURL(`reports/gift`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "gift_reports"
        },
        {
          name: "Trend Product Report",
          url: setURL(`reports/trendproducts`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "trend_product_reports"
        },
        {
          name: "Merchants Sales Report",
          url:  setURL(`reports/merchantsalesreport`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "merchant_sales_report"
        },
        {
          name: "Credit Record Report",
          url: setURL(`reports/creditrecord`, region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "contact_notes_report"
        },
        {
          name: "Contact Notes Report",
          url: setURL('reports/contactnotes', region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "contact_notes_report"
        },
        {
          name: "Chat Report",
          url: setURL('reports/chatreport', region),
          icon: "cui-file",
          permission: "ADMIN_REPORTS_ANY_READ",
          menuname: "chats_report"
        }
        // {
        //   name: "User Last Active",
        //   url: "/reports/userlastactive",
        //   icon: "cui-file",
        //   permission: "ADMIN_REPORTS_ANY_READ",
        //   menuname: "user_last_active"
        // },
      ],
      permission: "REPORTS_ANY_READ"
    },
    // {
    //   name: "Monitoring",
    //   url: "monitoring",
    //   icon: "fa fa-line-chart"
    // },
  ]
};

export default nav;
